"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CartValidation;
var _react = _interopRequireWildcard(require("react"));
var _api = require("../../service/api");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const QR_CODE_SIZE = 280;
const formatPrice = value => typeof value === 'number' ? value.toFixed(2).replace('.', ',') + ' €' : '—';
function parseTerminalEventDetail(raw) {
  if (raw == null) return {};
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  if (typeof raw === 'object') return raw;
  return {};
}

/**
 * @param {object} props
 * @param {(details: { kind: 'qr'|'terminal', paymentLink?: string }) => void} [props.onProceedToCheckout] — navigation vers l’écran paiement (WebView / parent)
 */
function CartValidation({
  cart,
  cartTotal,
  projectId,
  userDatas = {},
  labels = {},
  uri_transformer = url => url,
  onBack,
  /** @deprecated utilisez onProceedToCheckout */
  onPaymentLinkReceived,
  onProceedToCheckout
}) {
  const [paymentLink, setPaymentLink] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [error, setError] = (0, _react.useState)(null);
  const [waitingReaderPayment, setWaitingReaderPayment] = (0, _react.useState)(false);
  /** Secours si l’événement natif n’expose pas commandId (WebView / parsing). */
  const lastTerminalCommandIdRef = (0, _react.useRef)(null);
  const emitProceed = (0, _react.useCallback)(details => {
    setWaitingReaderPayment(false);
    if (typeof onProceedToCheckout === 'function') {
      onProceedToCheckout(details);
      return;
    }
    /* compat ancien pont : QR uniquement */
    if (details.kind === 'qr' && details.paymentLink && typeof onPaymentLinkReceived === 'function') {
      onPaymentLinkReceived(details.paymentLink);
    }
  }, [onProceedToCheckout, onPaymentLinkReceived]);
  (0, _react.useEffect)(() => {
    const onNativeResult = ev => {
      void (async () => {
        const d = parseTerminalEventDetail(ev.detail);
        const commandId = d.commandId || lastTerminalCommandIdRef.current;
        setLoading(false);
        setWaitingReaderPayment(false);
        const outcomeByStatus = {
          success: 'paid',
          cancelled: 'payment_cancelled',
          error: 'payment_failed'
        };
        const outcome = outcomeByStatus[d.status] || 'payment_failed';
        if (d.status === 'success') {
          lastTerminalCommandIdRef.current = null;
          emitProceed({
            kind: 'terminal',
            paymentLink: undefined,
            commandId,
            paymentIntentId: d.payment_intent_id
          });
          if (commandId) {
            void (0, _api.recordTerminalPaymentOutcome)(commandId, 'paid', d.payment_intent_id || undefined).catch(syncErr => {
              console.error(syncErr);
            });
          }
          return;
        }
        if (commandId) {
          void (0, _api.recordTerminalPaymentOutcome)(commandId, outcome, d.payment_intent_id || undefined).catch(syncErr => console.error(syncErr));
        }
        lastTerminalCommandIdRef.current = null;
        if (d.status === 'cancelled') {
          setError(d.message || 'Paiement annulé sur le terminal. Vous pouvez réessayer ou modifier votre panier.');
          return;
        }
        setError(d.message || 'Paiement carte refusé ou erreur technique');
      })();
    };
    /* document + bubbles:false (ancien inject natif) n’atteint pas window ; on écoute les deux. */
    window.addEventListener('pluracore-terminal-payment', onNativeResult);
    document.addEventListener('pluracore-terminal-payment', onNativeResult);
    return () => {
      window.removeEventListener('pluracore-terminal-payment', onNativeResult);
      document.removeEventListener('pluracore-terminal-payment', onNativeResult);
    };
  }, [emitProceed]);
  const handleConfirmAndPay = (0, _react.useCallback)(async () => {
    if (!projectId || cart.length === 0) return;
    setLoading(true);
    setError(null);
    let deferLoadingFinish = false;
    try {
      const products = cart.map(item => ({
        id: item.productId,
        quantity: item.quantity
      }));
      const command = await (0, _api.createCommand)(projectId, userDatas, products);
      const hasNativeTerminal = typeof window !== 'undefined' && window.AndroidTerminal && typeof window.AndroidTerminal.startTerminalPayment === 'function';
      if (hasNativeTerminal) {
        deferLoadingFinish = true;
        lastTerminalCommandIdRef.current = command.id;
        setWaitingReaderPayment(true);
        window.AndroidTerminal.startTerminalPayment(JSON.stringify({
          apiBaseUrl: _api.API_URI,
          projectId,
          commandId: command.id
        }));
        return;
      }
      const data = await (0, _api.getPaymentLink)(command.id);
      const url = typeof data === 'string' ? data : data?.url ?? data?.payment_link ?? data?.link;
      if (url) {
        if (onProceedToCheckout) {
          onProceedToCheckout({
            kind: 'qr',
            paymentLink: url
          });
        } else if (onPaymentLinkReceived) {
          onPaymentLinkReceived(url);
        } else {
          setPaymentLink(url);
        }
      } else {
        setError('Lien de paiement non reçu');
      }
    } catch (err) {
      setWaitingReaderPayment(false);
      setError(err?.response?.data?.message || err?.message || 'Erreur lors de la création de la commande');
    } finally {
      if (!deferLoadingFinish) {
        setLoading(false);
      }
    }
  }, [cart, projectId, userDatas, onPaymentLinkReceived, onProceedToCheckout]);
  if (!cart?.length) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cart-validation",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "cart-validation__empty",
        children: "Panier vide"
      }), onBack && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "cart-validation__back",
        onClick: onBack,
        children: "Retour"
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "cart-validation",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      className: "cart-validation__header",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: "cart-validation__title",
        children: labels.recap_title || 'Récapitulatif'
      }), onBack && !paymentLink && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "cart-validation__back",
        disabled: waitingReaderPayment,
        "aria-disabled": waitingReaderPayment,
        title: waitingReaderPayment ? 'Paiement en cours sur le terminal' : undefined,
        onClick: onBack,
        children: "Retour"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: "cart-validation__list",
      children: cart.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
        className: "cart-validation__item",
        children: [item.imageUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(item.imageUrl),
          alt: "",
          className: "cart-validation__item-img"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "cart-validation__item-info",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "cart-validation__item-name",
            children: item.productName
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "cart-validation__item-detail",
            children: [formatPrice(item.price), " \xD7 ", item.quantity]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "cart-validation__item-total",
          children: formatPrice(item.price * item.quantity)
        })]
      }, `${item.productId}-${item.priceId}-${index}`))
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cart-validation__total-row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "cart-validation__total-label",
        children: labels.total_prefix || 'Total'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "cart-validation__total-value",
        children: formatPrice(cartTotal)
      })]
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "cart-validation__error",
      role: "alert",
      children: error
    }), !paymentLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "cart-validation__actions",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "cart-validation__confirm",
        disabled: loading || waitingReaderPayment || !projectId,
        onClick: handleConfirmAndPay,
        children: waitingReaderPayment ? 'Suivez les instructions sur le terminal carte…' : loading ? 'Création en cours…' : 'Confirmer et payer'
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cart-validation__qrcode-section",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "cart-validation__qrcode-label",
        children: labels.qr_code_title || 'Scannez le QR code pour payer'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "cart-validation__qrcode-wrap",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: `https://api.qrserver.com/v1/create-qr-code/?size=${QR_CODE_SIZE}x${QR_CODE_SIZE}&data=${encodeURIComponent(paymentLink)}&bgcolor=ffffff&color=1a1a2e`,
          alt: "QR Code paiement",
          className: "cart-validation__qrcode",
          width: QR_CODE_SIZE,
          height: QR_CODE_SIZE
        })
      }), onBack && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "cart-validation__back cart-validation__back--bottom",
        onClick: onBack,
        children: "Retour au catalogue"
      })]
    })]
  });
}